(function () {
  function pageRoot(el) {
    return el && el.closest ? el.closest(".product-details") : null;
  }

  function journalFeed(details) {
    if (details) {
      var nested = details.querySelector('[data-mayekoo-updates-v2="feed"]');
      if (nested) return nested;
    }
    var feeds = document.querySelectorAll('[data-mayekoo-updates-v2="feed"]');
    var i;
    for (i = 0; i < feeds.length; i++) {
      if (!feeds[i].classList.contains("mayekoo-updates-v2--cause")) return feeds[i];
    }
    return null;
  }

  function placeJournalInPanel(details) {
    if (!details) return;
    var panel = details.querySelector('.product-details__information [data-tab-content="updates"]');
    if (!panel) return;
    var feed = journalFeed(details);
    if (!feed || panel.contains(feed)) return;
    if (feed.classList.contains("mayekoo-updates-v2--cause")) return;
    panel.appendChild(feed);
  }

  function revealFeed(feed, show) {
    if (!feed) return;
    feed.classList.toggle("is-tab-hidden", !show);
    feed.hidden = !show;
    if (show) {
      feed.removeAttribute("hidden");
      feed.style.removeProperty("display");
    }
  }

  function activatePageTab(details, name) {
    if (!details || !name) return;
    placeJournalInPanel(details);
    details.querySelectorAll(".product-details__tabs__button").forEach(function (btn) {
      var on = btn.getAttribute("data-tab") === name;
      btn.classList.toggle("active", on);
      btn.setAttribute("aria-selected", on ? "true" : "false");
    });
    details.querySelectorAll(".product-details__information [data-tab-content]").forEach(function (panel) {
      var on = panel.getAttribute("data-tab-content") === name;
      panel.classList.toggle("active", on);
      if (on && name === "updates" && !panel.id) panel.id = "updates";
    });
    revealFeed(journalFeed(details), name === "updates");
    if (name === "updates") {
      try {
        if ((window.location.hash || "").indexOf("updates") < 0 && window.history && window.history.replaceState) {
          window.history.replaceState(null, "", (window.location.pathname || "") + (window.location.search || "") + "#updates");
        }
      } catch (_error) {}
    }
  }

  function activateWidgetTab(widget, name) {
    if (!widget || (name !== "donate" && name !== "donors")) return;
    var tabsRoot = widget.querySelector("[data-mayekoo-tabs], [data-tabs]");
    if (!tabsRoot) return;
    tabsRoot.querySelectorAll("[data-mayekoo-tab], [data-tab]").forEach(function (btn) {
      var on = (btn.getAttribute("data-mayekoo-tab") || btn.getAttribute("data-tab")) === name;
      btn.classList.toggle("is-active", on);
      btn.setAttribute("aria-selected", on ? "true" : "false");
      btn.tabIndex = on ? 0 : -1;
    });
    widget.querySelectorAll("[data-mayekoo-tabpanel], [data-tabpanel]").forEach(function (panel) {
      var on = (panel.getAttribute("data-mayekoo-tabpanel") || panel.getAttribute("data-tabpanel")) === name;
      panel.classList.toggle("is-active", on);
      panel.hidden = !on;
      if (on) panel.removeAttribute("hidden");
      panel.setAttribute("aria-hidden", on ? "false" : "true");
    });
  }

  function keepSelectedPageTab(details) {
    if (!details) return;
    var active = details.querySelector(".product-details__tabs__button.active");
    var name = active && active.getAttribute("data-tab");
    if (!name) return;
    placeJournalInPanel(details);
    details.querySelectorAll(".product-details__information [data-tab-content]").forEach(function (panel) {
      panel.classList.toggle("active", panel.getAttribute("data-tab-content") === name);
    });
    if (name === "updates") revealFeed(journalFeed(details), true);
  }

  document.addEventListener(
    "click",
    function (event) {
      var target = event.target;
      if (!target || !target.closest) return;

      var pageBtn = target.closest(".product-details__tabs [data-tab]");
      if (pageBtn) {
        event.preventDefault();
        event.stopPropagation();
        if (event.stopImmediatePropagation) event.stopImmediatePropagation();
        var details = pageRoot(pageBtn);
        activatePageTab(details, pageBtn.getAttribute("data-tab"));
        window.requestAnimationFrame(function () {
          keepSelectedPageTab(details);
        });
        window.setTimeout(function () {
          keepSelectedPageTab(details);
        }, 50);
        return;
      }

      var widgetBtn = target.closest(".mayekoo-fundraiser [data-tabs] [data-tab], .mayekoo-fundraiser [data-mayekoo-tabs] [data-mayekoo-tab]");
      if (widgetBtn) {
        event.preventDefault();
        event.stopPropagation();
        if (event.stopImmediatePropagation) event.stopImmediatePropagation();
        activateWidgetTab(
          widgetBtn.closest(".mayekoo-fundraiser"),
          widgetBtn.getAttribute("data-mayekoo-tab") || widgetBtn.getAttribute("data-tab"),
        );
      }
    },
    true,
  );

  function wordSafeExcerpt(text) {
    var raw = String(text || "").replace(/\s+/g, " ").trim();
    if (!raw) return raw;
    if (/[.!?…]$/.test(raw)) return raw;
    if (!/[A-Za-z0-9]$/.test(raw)) return raw;
    var cut = raw.replace(/[A-Za-z0-9']+$/, "").replace(/[,\s;:–-]+$/, "").trim();
    if (cut.length >= 8) return cut + "…";
    return raw;
  }

  function fixExcerpts(scope) {
    (scope || document).querySelectorAll(".mayekoo-updates-v2__excerpt").forEach(function (el) {
      if (el.dataset.wordSafe === "1") return;
      var next = wordSafeExcerpt(el.textContent || "");
      if (next) el.textContent = next;
      el.dataset.wordSafe = "1";
    });
  }

  function bootDeepLink() {
    var wants = false;
    try {
      wants = !!(new URLSearchParams(window.location.search).get("update") || (window.location.hash || "").indexOf("updates") >= 0);
    } catch (_error) {}
    document.querySelectorAll(".product-details").forEach(function (details) {
      placeJournalInPanel(details);
      if (wants) activatePageTab(details, "updates");
    });
  }

  function init() {
    bootDeepLink();
    fixExcerpts();
  }

  if (document.readyState === "loading") document.addEventListener("DOMContentLoaded", init);
  else init();
  document.addEventListener("shopify:section:load", init);

  if (typeof MutationObserver !== "undefined") {
    var observer = new MutationObserver(function () {
      document.querySelectorAll(".product-details").forEach(placeJournalInPanel);
      fixExcerpts();
    });
    observer.observe(document.documentElement, { childList: true, subtree: true });
  }
})();
